<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()"
  (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <!-- External Id Control -->
    <div class="checkbox-group">
      <mat-checkbox id="{{ baseId }}-require-data-tag" formControlName="requireDataTag" translate>Require Data Tag
      </mat-checkbox>
      <mat-checkbox id="{{ baseId }}-allow-multi-checkbox" formControlName="allowMulti" translate>Allow Multi
      </mat-checkbox>
    </div>
    <div class="form-group">
      <label for="{{ baseId }}-id" translate>ID</label>
      <input id="{{ baseId }}-id" class="form-control" [ngClass]="{
          error: externalIdControl | showErrors : isSubmitted,
          'required': isRequired(externalIdControl)
        }" type="text" [maxlength]="fcListValidation.validations.ExternalID.MaxLength" formControlName="externalId" />
      <div *ngIf="externalIdControl | showErrors : isSubmitted" id="{{ baseId }}-warning-text-id"
        class="incorrect-input" translate>
        {{ externalIdControl.errors | fcListValidation : 'ID' }}
      </div>
    </div>
    <!-- External Id Control -->

    <!-- Name Control -->
    <div class="form-group">
      <label for="{{ baseId }}-name" translate>Name</label>
      <input id="{{ baseId }}-name" class="form-control" [ngClass]="{
          error: nameControl | showErrors : isSubmitted,
          'required': isRequired(nameControl)
        }" type="text" [maxlength]="fcListValidation.validations.Name.MaxLength" formControlName="name" />
      <div *ngIf="showErrors(nameControl, isSubmitted)" id="{{ baseId }}-warning-text-name" class="incorrect-input"
        translate>
        {{ nameControl.errors | fcListValidation : 'Name' }}
      </div>
    </div>
    <!-- Name Control -->

    <!-- UIControl FC -->
    <div class="form-group">
      <label for="{{ baseId }}-ui-control" translate>UI Control</label>
      <ap-findcontrol id="{{ baseId }}-ui-control" [baseId]="baseId" [apFormGroup]="form" controlName="uiControl"
        [findControlId]="FindControlIdService.ListUIControl" [(selectedPks)]="uiControlPkList" [placeHolder]=""
        [disabled]="false" [singleSelect]="true" [findControlMaxLength]="100" findControlDisplayName="UI Control"
        [required]="validationFields.UIControlUid | isRequiredFindControlValidation : fcListValidation"
        (dirty)="uiControlControl.markAsDirty()" [formGroupSubmitted]="isSubmitted" [form]="form">
      </ap-findcontrol>
      <div *ngIf="showErrors(nameControl, isSubmitted)" id="{{ baseId }}-warning-text-name" class="incorrect-input"
        translate>
        {{ nameControl.errors | fcListValidation : 'UI Control' }}
      </div>
    </div>
    <!-- UIControl FC -->

    <!-- UIConfiguration (Form Builder) FC -->
    <div class="form-group">
      <label for="{{ baseId }}-form-builder" translate>Form</label>
      <ap-findcontrol id="{{ baseId }}-form-builder" [baseId]="baseId" [apFormGroup]="form"
        controlName="uiConfiguration" [findControlId]="FindControlIdService.ViewFormBuilder"
        [(selectedPks)]="uiConfigurationPkList" [placeHolder]="" [disabled]="false" [singleSelect]="true"
        [findControlMaxLength]="100" findControlDisplayName="Form Builder"
        [required]="validationFields.UIConfigurationUid | isRequiredFindControlValidation : fcListValidation"
        (dirty)="uiConfigurationControl.markAsDirty()" [formGroupSubmitted]="isSubmitted" [form]="form">
      </ap-findcontrol>
      <div *ngIf="showErrors(uiConfigurationControl, isSubmitted)" id="{{ baseId }}-warning-text-form-builder"
        class="incorrect-input" translate>
        {{ uiConfigurationControl.errors | fcListValidation : 'Form' }}
      </div>
    </div>
    <!-- UIConfiguration (Form Builder) FC -->

    <!-- ListProcedure FC -->
    <div class="form-group" *ngIf="false"> <!-- TODO: this should show conditionally-->
      <label for="{{ baseId }}-procedure" translate>Procedure</label>
      <ap-findcontrol id="{{ baseId }}-procedure" [baseId]="baseId" [apFormGroup]="form" controlName="procedure"
        [findControlId]="FindControlIdService.ListProcedure" [(selectedPks)]="procedurePkList" [placeHolder]=""
        [disabled]="false" [singleSelect]="true" [findControlMaxLength]="100" findControlDisplayName="Procedure"
        [required]="validationFields.ProcedureUid | isRequiredFindControlValidation : fcListValidation"
        (dirty)="procedureControl.markAsDirty()" [formGroupSubmitted]="isSubmitted" [form]="form">
      </ap-findcontrol>
      <div *ngIf="showErrors(uiConfigurationControl, isSubmitted)" id="{{ baseId }}-warning-text-ui-configuration"
        class="incorrect-input" translate>
        {{ uiConfigurationControl.errors | fcListValidation : 'Procedure' }}
      </div>
    </div>
    <!-- ListProcedure FC -->

    <!-- Title Definition -->
    <div class="form-group">
      <label for="{{ baseId }}-title-definition" translate>Title Definition</label>
      <input id="{{ baseId }}-title-definition" class="form-control" [ngClass]="{
          error: titleDefinitionControl | showErrors : isSubmitted,
          'required': isRequired(titleDefinitionControl)
        }" type="text" formControlName="titleDefinition" />
      <div *ngIf="titleDefinitionControl | showErrors : isSubmitted" id="{{ baseId }}-warning-text-title-definition"
        class="incorrect-input" translate>
        {{ titleDefinitionControl.errors | fcListValidation : validationFields.TitleDefinition }}
      </div>
    </div>
    <!-- Title Definition -->

    <!-- Notes Control -->
    <div class="form-group full-control">
      <label for="{{ baseId }}-notes" translate>Notes</label>
      <textarea class="form-control" [ngClass]="{
          error: notesControl | showErrors : isSubmitted,
          'required': isRequired(notesControl)
        }" id="{{ baseId }}-notes" formControlName="notes"
        [maxlength]="fcListValidation.validations[validationFields.Notes].MaxLength" rows="3">
      </textarea>
      <div *ngIf="notesControl | showErrors : isSubmitted" id="{{ baseId }}-warning-text-notes" class="incorrect-input"
        translate>
        {{ notesControl.errors | fcListValidation : validationFields.Notes }}
      </div>
    </div>
    <!-- Notes Control -->

    <!-- Inactive and User Defined checkboxes -->
    <div class="checkbox-group">
      <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate>Inactive </mat-checkbox>
      <mat-checkbox id="{{ baseId }}-user-defined-checkbox" formControlName="userDefined" translate>User Defined
      </mat-checkbox>
    </div>
    <!-- Inactive and User Defined checkboxes -->
  </div>
</fc-general-modal>
